import { Component, Input } from '@angular/core';
import { UpsellCardComponent } from '@components/upsell-card/upsell-card.component';
import { UpsellSlugs } from '@enums/upsell-slugs';

@Component({
  selector: 'app-metformin',
  imports: [UpsellCardComponent],
  templateUrl: './metformin.component.html',
})
export class MetforminComponent {
  @Input() public htmlTitle: string = '';
  @Input() public question: string = '';
  public readonly slug: UpsellSlugs = UpsellSlugs.Metformin;
}
